<template>
    <v-snackbar 
        v-model="hidden" 
        :color="color" 
        top
        :timeout="timeout"
        role="alert"
        aria-live="polite"
        :aria-atomic="true"
    >
        <!-- Prefixo de status para leitores de tela -->
        <span class="sr-only">{{ statusPrefix }}</span>
        
        <span v-if="message && message != ''">{{ message }}</span>
        <ul v-else aria-label="Lista de erros">
            <li :key="i" v-for="(error, i) in errors">
                {{ error.toString().replace('[ "', '').replace('" ]', '') }}
            </li>
        </ul>
        
        <template v-slot:action="{ attrs }">
        <slot name='action' />
        <v-btn 
            class="float-right ma-1" 
            icon 
            @click="hidden = false" 
            v-bind="attrs"
            small
            aria-label="Fechar notificação"
            >
            <v-icon aria-hidden="true">mdi-close</v-icon>
        </v-btn>
        </template>
      </v-snackbar>
</template>

<script>
export default {
    name: "EmcAlertSnackbar",
    data: () => ({
        hidden: false
    }),
    props: {
        show: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'success'
        },
        message: {
            type: String,
            default: null
        },
        timeout: {
            default: 5000
        },
        errors: {
            default: null
        },
    },
    computed: {
        /**
         * Prefixo de status para leitores de tela
         * Fornece contexto sobre o tipo de mensagem
         */
        statusPrefix() {
            const prefixes = {
                'success': 'Sucesso:',
                'error': 'Erro:',
                'warning': 'Atenção:',
                'info': 'Informação:',
                'red': 'Erro:',
                'green': 'Sucesso:',
                'orange': 'Atenção:'
            }
            return prefixes[this.color] || 'Notificação:'
        }
    },
    watch: {
        hidden(){
             this.$emit('update:show', this.hidden);
        },
        show(){
            this.hidden = this.show;
        }
    },
}
</script>